import { styled } from 'styled-components';

import { Row } from '~/components/Row';
import { getMediaQuery } from '~/utils/responsive/media';

export const SearchContainer = styled(Row)`
  ${getMediaQuery('mobile', 'tablet')} {
    flex-direction: column;
  }
`;
